module.exports = __webpack_public_path__ + "img/chalk_4.c0d95f3e.png";